
export function renderAuthenticated(isAuthenticated) {
    return isAuthenticated ? ' ' : ' d-none';
}

export function renderAdmin(isAdmin) {
    return isAdmin ? ' ' : ' d-none';
}


// WEBPACK FOOTER //
// ./src/components/Common/Utilities.js